//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './VersionClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

    
export function maintenanceUrl(): string {
  let url_ = getBaseUrl() + "/maintenance";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let maintenanceDefaultOptions: UseQueryOptions<Types.MaintenanceDto, unknown, Types.MaintenanceDto> = {
  queryFn: __maintenance,
};
export function getMaintenanceDefaultOptions(): UseQueryOptions<Types.MaintenanceDto, unknown, Types.MaintenanceDto> {
  return maintenanceDefaultOptions;
};
export function setMaintenanceDefaultOptions(options: UseQueryOptions<Types.MaintenanceDto, unknown, Types.MaintenanceDto>) {
  maintenanceDefaultOptions = options;
}

export function maintenanceQueryKey(): QueryKey;
export function maintenanceQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'VersionClient',
      'maintenance',
    ]);
}
function __maintenance() {
  return Client.maintenance(
    );
}

/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function useMaintenanceQuery<TSelectData = Types.MaintenanceDto, TError = unknown>(options?: UseQueryOptions<Types.MaintenanceDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useMaintenanceQuery<TSelectData = Types.MaintenanceDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MaintenanceDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.MaintenanceDto, TError, TSelectData>({
    queryFn: __maintenance,
    queryKey: maintenanceQueryKey(),
    ...maintenanceDefaultOptions as unknown as UseQueryOptions<Types.MaintenanceDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function setMaintenanceData(queryClient: QueryClient, updater: (data: Types.MaintenanceDto | undefined) => Types.MaintenanceDto, ) {
  queryClient.setQueryData(maintenanceQueryKey(),
    updater
  );
}

/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function setMaintenanceDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MaintenanceDto | undefined) => Types.MaintenanceDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function versionUrl(): string {
  let url_ = getBaseUrl() + "/api";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let versionDefaultOptions: UseQueryOptions<string, unknown, string> = {
  queryFn: __version,
};
export function getVersionDefaultOptions(): UseQueryOptions<string, unknown, string> {
  return versionDefaultOptions;
};
export function setVersionDefaultOptions(options: UseQueryOptions<string, unknown, string>) {
  versionDefaultOptions = options;
}

export function versionQueryKey(): QueryKey;
export function versionQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'VersionClient',
      'version',
    ]);
}
function __version() {
  return Client.version(
    );
}

/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function useVersionQuery<TSelectData = string, TError = unknown>(options?: UseQueryOptions<string, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useVersionQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<string, TError, TSelectData>({
    queryFn: __version,
    queryKey: versionQueryKey(),
    ...versionDefaultOptions as unknown as UseQueryOptions<string, TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function setVersionData(queryClient: QueryClient, updater: (data: string | undefined) => string, ) {
  queryClient.setQueryData(versionQueryKey(),
    updater
  );
}

/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function setVersionDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function appVersionUrl(): string {
  let url_ = getBaseUrl() + "/app";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let appVersionDefaultOptions: UseQueryOptions<Types.SupportedAppVersions, unknown, Types.SupportedAppVersions> = {
  queryFn: __appVersion,
};
export function getAppVersionDefaultOptions(): UseQueryOptions<Types.SupportedAppVersions, unknown, Types.SupportedAppVersions> {
  return appVersionDefaultOptions;
};
export function setAppVersionDefaultOptions(options: UseQueryOptions<Types.SupportedAppVersions, unknown, Types.SupportedAppVersions>) {
  appVersionDefaultOptions = options;
}

export function appVersionQueryKey(): QueryKey;
export function appVersionQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'VersionClient',
      'appVersion',
    ]);
}
function __appVersion() {
  return Client.appVersion(
    );
}

/**
 * Provides information about mobile app versions.
 */
export function useAppVersionQuery<TSelectData = Types.SupportedAppVersions, TError = unknown>(options?: UseQueryOptions<Types.SupportedAppVersions, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAppVersionQuery<TSelectData = Types.SupportedAppVersions, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SupportedAppVersions, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.SupportedAppVersions, TError, TSelectData>({
    queryFn: __appVersion,
    queryKey: appVersionQueryKey(),
    ...appVersionDefaultOptions as unknown as UseQueryOptions<Types.SupportedAppVersions, TError, TSelectData>,
    ...options,
  });
}
/**
 * Provides information about mobile app versions.
 */
export function setAppVersionData(queryClient: QueryClient, updater: (data: Types.SupportedAppVersions | undefined) => Types.SupportedAppVersions, ) {
  queryClient.setQueryData(appVersionQueryKey(),
    updater
  );
}

/**
 * Provides information about mobile app versions.
 */
export function setAppVersionDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SupportedAppVersions | undefined) => Types.SupportedAppVersions) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function throwErrorUrl(): string {
  let url_ = getBaseUrl() + "/error-test";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let throwErrorDefaultOptions: UseQueryOptions<string, unknown, string> = {
  queryFn: __throwError,
};
export function getThrowErrorDefaultOptions(): UseQueryOptions<string, unknown, string> {
  return throwErrorDefaultOptions;
};
export function setThrowErrorDefaultOptions(options: UseQueryOptions<string, unknown, string>) {
  throwErrorDefaultOptions = options;
}

export function throwErrorQueryKey(): QueryKey;
export function throwErrorQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'VersionClient',
      'throwError',
    ]);
}
function __throwError() {
  return Client.throwError(
    );
}

/**
 * Demonstrates an error response.
 */
export function useThrowErrorQuery<TSelectData = string, TError = unknown>(options?: UseQueryOptions<string, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useThrowErrorQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<string, TError, TSelectData>({
    queryFn: __throwError,
    queryKey: throwErrorQueryKey(),
    ...throwErrorDefaultOptions as unknown as UseQueryOptions<string, TError, TSelectData>,
    ...options,
  });
}
/**
 * Demonstrates an error response.
 */
export function setThrowErrorData(queryClient: QueryClient, updater: (data: string | undefined) => string, ) {
  queryClient.setQueryData(throwErrorQueryKey(),
    updater
  );
}

/**
 * Demonstrates an error response.
 */
export function setThrowErrorDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}